import { logger } from '$lib/logger';
import { api } from '$lib/utils/api.js';
import { createMutation, createQuery } from '@tanstack/svelte-query';

export const getVideoMeeting = (eventId) =>
  api().get(`nurse/videoMeeting/forEvent/${eventId}`);

export const videoEventHistoryOptions = ({ id }, options = {}) => ({
  queryKey: ['videoEventHistory', id],
  queryFn: () => api().get(`v2/calendar/videoEventHistory/${id}`),
  ...options,
});

export const useGetVideoEventHistory = (props, options = {}) =>
  createQuery(videoEventHistoryOptions(props, options));

export const useInsertVideoEventHistory = (options = {}) =>
  createMutation({
    mutationFn: (props) => {
      const { eventId, data } = props;
      if (!eventId) {
        logger.debug('Event ID is required');
        return null;
      }
      return api().post(`v2/calendar/videoEventHistory/${eventId}`, data);
    },
    ...options,
  });
